import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=c3af67c6&scoped=true&"
import script from "./dispatch.vue?vue&type=script&lang=js&"
export * from "./dispatch.vue?vue&type=script&lang=js&"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=c3af67c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3af67c6",
  null
  
)

export default component.exports